import React, { RefObject } from 'react'
import { Chip, TableCell, Box } from '@mui/material'
import { Dayjs } from 'dayjs'
import { Project } from '../../store/types'
import Demand from '../../store/types/models/Demand'
import { t } from 'i18next'
import VacancyMenuPopup from './VacancyMenuPopup'

type VacancyHeaderChipProps = {
  month: Dayjs
  stateProjects: Project[]
  demandResponse: Demand[]
  isEditionDisabled: () => boolean
  vacancyRef: React.RefObject<HTMLButtonElement>
  addEmployeeRef: RefObject<HTMLButtonElement>
  firstProjectRef: RefObject<HTMLDivElement>
}

const VacancyHeaderChip: React.FC<VacancyHeaderChipProps> = ({
  month,
  stateProjects,
  demandResponse,
  isEditionDisabled,
  vacancyRef,
  addEmployeeRef,
  firstProjectRef
}) => {
  return (
    <TableCell align="center" sx={{ borderBottom: '1px solid', borderColor: 'background.elevation8' }}>
      <Chip
        color="default"
        label={
          <Box display="flex" alignItems="center">
            {t('components.vacancyTable.header')}
            <VacancyMenuPopup
              month={month}
              stateProjects={stateProjects}
              demandResponse={demandResponse}
              isEditionDisabled={isEditionDisabled}
              vacancyRef={vacancyRef}
              addEmployeeRef={addEmployeeRef}
              firstProjectRef={firstProjectRef}
            />
          </Box>
        }
        size="small"
        variant="outlined"
        sx={{
          '.MuiChip-label': { p: 0, mx: 1 },
          '& .MuiChip-deleteIcon': {
            visibility: 'hidden',
          },
          '&:hover': {
            '& .MuiChip-deleteIcon': {
              visibility: 'visible',
            },
          },
          ':focus': {
            '& .MuiChip-deleteIcon': {
              visibility: 'visible',
            },
          },
        }}
      />
    </TableCell>
  )
}

export default VacancyHeaderChip
